import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export var SET_CUSTOMER = 'SET_CUSTOMER';
export var SET_CART = 'SET_CART';
export var SET_CART_QTY = 'SET_CART_QTY';
export var SET_CURRENT_ITEM_QTY = 'SET_CURRENT_ITEM_QTY';
export var SET_CART_SUCCESS = 'SET_CART_SUCCESS';